import TPremiaCard from "@/components/t-premia-card/t-premia-card";
import { ContainerCard, ContentActions, DetailsContainer, LoginContentInputStyled, LoginFormStyled, PageContainer, SocialButtonsContainer, TermsOfService } from "./style-component";
import { Form } from "antd";
import FBIcon from "@/assets/icons/social/facebook-color.svg"
import GoogleIcon from "@/assets/icons/social/google-color.svg"
import { AuthProviers } from "@/contexts/auth-context/auth-types";
import CustomButton from "@/components/custom-button/custom-button";
import { useUserContext } from "@/contexts/user/useUserContext";
import brandData from "@/assets/brand.json"
import { useTheme } from "styled-components";
import { amplitudeAddTrack } from "@/utils/amplitud/event-track";
import EnterSiteWarning from "@/components/enter-site-warning/enter-site-warning";
import TwitterIcon from "@/assets/icons/social/twitter-icon";
import { Link } from "react-router-dom";

const styleButtons: React.CSSProperties = {
	width: "100%",
	display: "flex",
	justifyContent: "flex-start",
}

interface FormValues {
	email: string;
}

const LoginPage: React.FC = () => {
	const [form] = Form.useForm<FormValues>();
	const { loginWithEmail, loginWithSocialProvider, loading } = useUserContext();

	const { isDark } = useTheme();

	const handleSocialLogin = (provider: AuthProviers) => {
		amplitudeAddTrack('SocialSign In', {
			method: provider,
			timestamp: new Date().toISOString(),
		});
		loginWithSocialProvider(provider);
	}

	const handleEmailLogin = (values: FormValues) => {
		if (values.email) {
			amplitudeAddTrack('Email Sign In', {
				method: 'Email',
				timestamp: new Date().toISOString(),
			});
			loginWithEmail(values.email);
		}
	}

	const validateEmail = (_: object, value: string) => {
		if (!value) {
			return Promise.reject(new Error('El campo es requerido'));
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(value)) {
			return Promise.reject(new Error('Por favor ingresa un correo electrónico válido'));
		}

		return Promise.resolve();
	};

	return (
		<PageContainer>
			{import.meta.env.VITE_SHOW_ENTER_SITE_MODAL === "true" &&
				<EnterSiteWarning />
			}
			<div>
				<ContainerCard>
					<TPremiaCard style={{ margin: 0, padding: 0, boxShadow: "none", border: "none" }} variant="dark">
						<DetailsContainer>
							<img alt="Google" width={"126px"} height={"32px"} src={isDark ? brandData.logos.primary.dark : brandData.logos.primary.light} />
							<h4>Regístrate o inicia sesión con</h4>
							<ContentActions>
								<SocialButtonsContainer>
									<CustomButton
										color="dark"
										style={styleButtons}
										type="primary"
										data-testid="google-button"
										icon={<img alt="Google" width={"16px"} src={GoogleIcon} />}
										onClick={() => handleSocialLogin("google")}
										disabled={loading}
									>
										Google
									</CustomButton>
									<CustomButton
										color="dark"
										style={styleButtons}
										type="primary"
										data-testid="facebook-button"
										icon={<img alt="Facebook" width={"16px"} src={FBIcon} />}
										onClick={() => handleSocialLogin("facebook")}
										disabled={loading}
									>
										Facebook
									</CustomButton>
									<CustomButton
										color="dark"
										style={styleButtons}
										type="primary"
										data-testid="twitter-button"
										icon={<TwitterIcon />}
										onClick={() => handleSocialLogin("twitter")}
										disabled={loading}
									>
										X (Twitter)
									</CustomButton>
								</SocialButtonsContainer>
								{/*<DividerStyled>o</DividerStyled>*/}
								<LoginFormStyled
									layout="vertical"
									form={form}
									onFinish={handleEmailLogin}
									className="login-form-styled"
								>
									<Form.Item
										label="Correo"
										style={{ width: '100%', margin: 0 }}
										rules={[{ validator: validateEmail }]}
										name="email"
									>
										<LoginContentInputStyled
											placeholder="example@domain.com"
											autoComplete="off"
											disabled={loading}
										/>
									</Form.Item>
									<CustomButton
										htmlType="submit"
										type="primary"
										disabled={loading}
									>
										Enviar enlace
									</CustomButton>
								</LoginFormStyled>
							</ContentActions>
							<TermsOfService>Al entrar, aceptas los <Link to="/terms-and-conditions">Términos y Condiciones</Link> y la <Link to="/privacy-policy">Política de Privacidad</Link></TermsOfService>
						</DetailsContainer>
					</TPremiaCard>
				</ContainerCard>
			</div>
		</PageContainer>
	);
};

export default LoginPage;